import { createSlice } from '@reduxjs/toolkit';
/* eslint-disable no-param-reassign */
export const emailVerificationSlice = createSlice({
  name: 'verification',
  initialState: {
    email: '',
  },

  reducers: {
    setEmail: (state, action) => {
      state.email = '';
      state.email = action.payload;
    },
  },
});

export const { setEmail } = emailVerificationSlice.actions;

export default emailVerificationSlice.reducer;
